import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const SepaIcon = (props: WrappingIconProps) => (
  <Icon {...props}>
    <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.00001 7.5V14H6.50001V7.5H9.50001V14H11V7.5H14V14H15C15.2652 14 15.5196 14.1054 15.7071 14.2929C15.8947 14.4804 16 14.7348 16 15V16H8.63976e-06V15C8.63976e-06 14.7348 0.105365 14.4804 0.292902 14.2929C0.480438 14.1054 0.734792 14 1.00001 14H2.00001V7.5H5.00001ZM8.00001 0C12.681 2.572 15.181 3.95 15.5 4.134C15.6922 4.24488 15.8421 4.41655 15.926 4.62197C16.01 4.82739 16.0232 5.05489 15.9636 5.26865C15.904 5.48241 15.7751 5.67028 15.597 5.80269C15.4189 5.93509 15.2019 6.00451 14.98 6H1.02001C0.79815 6.00451 0.581093 5.93509 0.403019 5.80269C0.224944 5.67028 0.0959681 5.48241 0.0363994 5.26865C-0.0231692 5.05489 -0.00994609 4.82739 0.0739866 4.62197C0.157919 4.41655 0.307793 4.24488 0.500009 4.134C0.820009 3.95 3.32001 2.572 8.00001 0Z"
    fill="#5F5E70"/>
  </Icon>
);
